import Image from "next/image";
import IMAGES from "../../../../../images/importImages";
import { conditions, controllbarIconSize } from "../../../../../helpers";
import { ConditionName, ISpeedIconProps } from "../../../../../interfaces";
import { useAppSelector } from "redux-share";
import { shallowEqual } from "react-redux";

const SpeedIcon = (props: ISpeedIconProps) => {
    useAppSelector(({ controller: { showMiniPlayer } }) => ({ showMiniPlayer }), shallowEqual);
    useAppSelector(({ videoData: { videoElementSizeInfo, params } }) => ({ videoElementSizeInfo, params }), shallowEqual);

    return (
        <>
            {conditions(ConditionName.isSplusEnvironment) ? (
                <i
                    className={`fa-solid fa-gauge pl-cursor-pointer pl-text-white ${
                        conditions(ConditionName.isFullMobilePortrait) || !conditions(ConditionName.isMiniPlayer)
                            ? controllbarIconSize.otherFontAwesome
                            : controllbarIconSize.miniPlayerFontAwesome
                    }`}
                    {...props}
                />
            ) : (
                <Image
                    alt="speed-icon"
                    src={IMAGES.speed}
                    className="pl-flex pl-items-center pl-cursor-pointer"
                    width={
                        conditions(ConditionName.isFullMobilePortrait) || !conditions(ConditionName.isMiniPlayer)
                            ? controllbarIconSize.other
                            : controllbarIconSize.miniPlayer
                    }
                    height={
                        conditions(ConditionName.isFullMobilePortrait) || !conditions(ConditionName.isMiniPlayer)
                            ? controllbarIconSize.other
                            : controllbarIconSize.miniPlayer
                    }
                    {...props}
                />
            )}
        </>
    );
};

export default SpeedIcon;
